import(/* webpackMode: "eager" */ "D:\\Program Files (x86)\\VERASOFT\\KORVUE-XL\\rxl.new-20261019-1132\\src\\app\\book\\page.tsx");
